import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import ClientTip from '../client-tip';
import User from '../../core/auth/user';
import {DialogService} from '../../core/dialog/dialog.service';
import {filter} from 'rxjs/operators';

@Component({
    selector: 'zah-client-tips',
    templateUrl: './client-tips.component.html',
    styleUrls: ['./client-tips.component.scss'],
    standalone: false
})
export class ClientTipsComponent {
  private dialogService = inject(DialogService);

  @Input()
  clientTips: Array<ClientTip>;
  @Input()
  user: User;
  @Output()
  clientTipAdded: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  clientTipEdited: EventEmitter<[ClientTip, string]> = new EventEmitter<[ClientTip, string]>();
  @Output()
  clientTipDeleted: EventEmitter<ClientTip> = new EventEmitter<ClientTip>();

  getClientTipId(index: number, clientTip: ClientTip): string {
    return clientTip.getId();
  }

  onTipClick(clientTip: ClientTip): void {
    this.dialogService.showInformation(clientTip.getContent());
  }

  onEditClick(clientTip: ClientTip): void {
    this.dialogService.askText({
      label: 'Tip wijzigen',
      placeholder: 'Wijzig tip',
      text: clientTip.getContent(),
      confirmLabel: 'Wijzigen'
    }).subscribe(content => this.clientTipEdited.emit([clientTip, content]));
  }

  onDeleteClick(clientTip: ClientTip): void {
    this.dialogService
      .askConfirmation({message: 'Ben je zeker dat je de tip wil verwijderen?'})
      .pipe(filter(confirmation => confirmation))
      .subscribe(() => this.clientTipDeleted.emit(clientTip));
  }

  onAddClick(): void {
    this.dialogService
      .askText({
        label: 'Nieuwe tip',
        placeholder: 'Voer een nieuwe tip in',
        confirmLabel: 'Bewaar',
      })
      .subscribe(tip => this.clientTipAdded.emit(tip));
  }
}
